<div class="p-6 bg-[--lightRed] rounded-xl min-h-[80vh] mx-4 sm:mx-8 md:mx-16 lg:mx-[200px] my-5">
  <h5 class="text-xs sm:text-sm font-bold text-white mb-4 text-center py-5">
    <i class="bx bx-book text-white"></i> Questões Disponíveis
  </h5>

  <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
    <div *ngIf="isLoading" class="col-span-full text-center">
      <p class="text-xl text-white">Carregando perguntas...</p>
    </div>

    <div *ngFor="let question of questions" class="bg-white rounded-lg shadow-lg p-4 flex flex-col justify-between">
      <div>
        <div class="flex items-center justify-between mb-4">
          <span class="text-lg font-semibold text-[--lightRed]">{{ question.code }}</span>
        </div>

        <div class="text-sm text-gray-700 mb-4 question truncate" [innerHTML]="question.question"></div>

        <div class="text-xs text-gray-500 mb-4">
          <strong>Tipo de Pergunta:</strong> {{ question.question_type === 'mult' ? 'Múltipla Escolha' : 'Verdadeiro/Falso' }}<br>
          <strong>Dificuldade:</strong> {{ question.difficulty }}<br>
          <strong>Ano:</strong> {{ question.year }}
        </div>
      </div>

      <div class="flex items-center justify-between mt-4">
        <button class="px-4 py-2 bg-blue-400 text-white rounded-md hover:bg-red-600 transition" [routerLink]="['/question', question.code]">
          Abrir <i class='bx bx-link-external'></i>
        </button>
        <i *ngIf="question.status" class="bx bx-check-circle text-green-500 text-xl"></i>
        <i *ngIf="!question.status" class="bx bx-x-circle text-red-500 text-xl"></i>
      </div>
    </div>
  </div>
</div>
